import { useMutation } from '@tanstack/react-query';
import { Appointment } from 'src/models/appointment';
import { api } from 'src/services/api';
import { useAppointmentDetailsClient, useAppointmentListClient } from '.';

export type UseConvertAppointmentToAuraOnlyPayload = {
  appt_uuid: Appointment['appt_uuid'];
};

export const useConvertAppointmentToAuraOnly = () => {
  const { invalidate } = useAppointmentListClient();
  const { invalidate: invalidateAppointmentDetails } =
    useAppointmentDetailsClient();

  return useMutation({
    mutationKey: ['convertAppointmentToAuraOnly'],
    mutationFn: ({ appt_uuid }: UseConvertAppointmentToAuraOnlyPayload) => {
      return api
        .put(`/appointment_convert_to_aura_encounter/${appt_uuid}`)
        .then(({ data }) => data);
    },
    onSuccess: (_, { appt_uuid }) => {
      invalidate();
      invalidateAppointmentDetails({ appt_uuid });
    },
  });
};
